<template>
  <div :class="$style.clearAll" @click="clearValues">clear all values</div>
  <AutoComplete v-bind="attrs" multiple :pt="passThrough" :typeahead="false" />
</template>

<script setup lang="ts">
import AutoComplete from "primevue/autocomplete";
import { useAttrs } from "vue";

const attrs = useAttrs();

const passThrough = {
  root: {
    style: {
      width: "100%",
      padding: "0.15rem 0.3rem",
    },
  },
  container: {
    style: {
      width: "100%",
      "max-height": "170px",
      "font-size": "12px",
      overflow: "scroll",
    },
  },
  input: {
    style: {
      width: "100%",
      height: "32px",
      "font-size": "12px",
    },
  },
  token: {
    style: {
      margin: "0.2rem 0.1rem",
    },
  },
};

const emit = defineEmits<{
  (e: "clear-values"): void;
}>();

const clearValues = () => {
  emit("clear-values");
};
</script>

<style module lang="scss">
.clearAll {
  font-size: 11px;
  color: var(--vd-color-blue-default);
  margin-bottom: -8px;
  margin-left: 6px;
  cursor: pointer;
}
</style>
